import { useEffect, useRef } from "react";

export const barcodeSupported = typeof window !== "undefined" && "BarcodeDetector" in window;

// Polls the live <video> with the native BarcodeDetector while enabled.
// A code fires once while it stays in frame; it can fire again only after
// it has been out of view for `absentMs` (e.g. the next product).
export function useBarcodeScan(videoRef, enabled, onCode, absentMs = 1200) {
  const cb = useRef(onCode);
  cb.current = onCode;

  useEffect(() => {
    if (!enabled || !barcodeSupported) return undefined;
    let stop = false;
    let lastCode = null;
    let lastSeen = 0;
    let detector;
    try {
      detector = new window.BarcodeDetector();
    } catch {
      return undefined;
    }
    const tick = async () => {
      if (stop) return;
      const v = videoRef.current;
      if (v && v.videoWidth) {
        try {
          const found = await detector.detect(v);
          const raw = found?.[0]?.rawValue;
          const now = Date.now();
          if (!raw && lastCode && now - lastSeen > absentMs) lastCode = null;
          if (raw) {
            if (raw !== lastCode) {
              lastCode = raw;
              cb.current(raw);
            }
            lastSeen = now;
          }
        } catch { /* frame not ready */ }
      }
      if (!stop) setTimeout(tick, 300);
    };
    tick();
    return () => { stop = true; };
  }, [enabled, videoRef, absentMs]);
}
